module.exports = "/_next/static/images/icon_letdoit-91064b247bdeb7dbc4ede53b2e69e3cf.svg";